import { render } from "./feature-course.vue?vue&type=template&id=42d699fe"
import script from "./feature-course.vue?vue&type=script&lang=js"
export * from "./feature-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__